import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import { InstagramPost } from "../../../models/instagram/instagramPost";
import { LocationData } from "../../../models/LocationData";

import "./styles.scss";

interface InstagramPostItemProps {
  locationData: LocationData;
  isShowLocationName?: boolean;
  post: InstagramPost;
}

export const InstagramPostItem: React.FC<InstagramPostItemProps> = ({
  post,
  locationData,
  isShowLocationName = true,
}) => {
  const postUrl = `https://www.instagram.com/p/${post.shortcode}`;

  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`dashboardPage.instagramPostItem.${key}`);

  return (
    <div className="instagram-post-item">
      <a key={post.id} href={postUrl} target="_blank" rel="noreferrer">
        <div className="instagram-post-top-info">
          <div className="left-title">
            {isShowLocationName ? locationData.name : ""}
          </div>
          <div className="right-title">
            {dayjs(post.timestamp).format("YYYY-MM-DD")}
          </div>
        </div>
        <div className="instagram-post-bottom-container">
          <div className="instagram-post-img-container">
            {post.media_url ? (
              <img
                className="instagram-post-img"
                alt={post.caption}
                src={post.media_url}
              />
            ) : (
              <div className="no-image">
                <div>{t("no_picture")}</div>
              </div>
            )}
          </div>
          {post.caption ? (
            <div className="summary">{post.caption}</div>
          ) : (
            <div className="no-summary">{t("no_comment")}</div>
          )}
        </div>
      </a>
    </div>
  );
};
